// Store links for the Autonoma mobile app — wired now so they work
// automatically the moment the apps are published (they won't resolve
// until then). Shared by the Dashboard capability modal and the
// Settings mobile-integration help.
export const MOBILE_APP_LINKS = {
  ios: 'https://apps.apple.com/app/id6805165887',
  android: 'https://play.google.com/store/apps/details?id=com.ontechnologies.autonomaai',
};

export default MOBILE_APP_LINKS;
